import React, { useState } from 'react'
import useRefs from "react-use-refs";
import axios from 'axios';
import { decodeToken } from "react-jwt";
import Dashboard from '../Dashboard';
import Categories from './Categories';



function EditCategory({ categoryDetail }) {
    const token = localStorage.getItem("access_token");
    const decodedToken = decodeToken(token);
    const {REACT_APP_API_URL} = process.env;
    const [currentPage, setCurrentPage] = useState("");
    const [
        id,
        name,
    ] = useRefs();

    const switchPage = (page) => {
        setCurrentPage(page);
    };

    if (currentPage === "category") {
        return (<Categories />)
    }

    const formData = new FormData();

    const handleSubmit = async (e) => {
        e.preventDefault();
        formData.append("id", id.current.value);
        formData.append("name", name.current.value);
        try {
            const response = await axios.post(
                `${REACT_APP_API_URL}/update-category`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            );
            if (response.status === 200) {
                setCurrentPage("category");
            }
        } catch (error) { }
    }
    if (decodedToken.role === 1) {
        return (
            <div className="container product-section">
                <div className="shop-section">
                    <button className='back-btn' onClick={() => switchPage("category")}>Back</button>
                    <div className="form-fields">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <input type="hidden" defaultValue={categoryDetail.id} ref={id} />
                            <label>Category Name</label>
                            <input type="text" className="field" defaultValue={categoryDetail.category_name} ref={name} />
                            <input className="login-btn" type="submit" value="Edit category" />
                        </form>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (<Dashboard />)
    }
}

export default EditCategory